import axios from 'axios'
import {
	Message,
	// Loading
} from 'element-ui'

var instance = axios.create({
	//baseURL: 'http://ssgtest.tmocloud.com/ssg/api',
	baseURL: process.env.VUE_APP_BASEURLSERVICEPAY,
	// baseURL: 'http://apidoc.tmocloud.com:8081/api/app/mock/30',
	// baseURL: 'http://172.16.87.58:8086/payroll/api/',
	//baseURL: 'http://172.16.93.75:8084/attend/api',
	//baseURL: 'http://172.16.94.172:8084/attend/api',
	//baseURL: 'http://172.16.96.229:8083/ssg/api',
	//baseURL: 'http://172.16.93.84:8084/attend/api',  
	timeout: 10000,
	withCredentials: true,
	headers: {
    // 'Content-Type':'application/x-www-form-urlencoded',
		'accept': 'application/json, text/plain, */*',
		'X-Requested-With': 'XMLHttpRequest'
	}
});

instance.interceptors.response.use((response) => {
	return response;
}, (error) => {
	if (error && error.response) {
		const status = error.response.status
		switch (status) {
			case 401:
				Message.error('登录超时，请重新登录')
				// window.location.href = 'http://sshr.tmocloud.com/sshrserver/#/login';	
				window.location.href =  process.env.VUE_APP_BASEURLSERVICEMAIN+'#/login';		
				break
			case 403:
				Message.warning('您没有操作该模块的权限，如要继续请联系管理员')
				break
		}
	}
})

export default instance
